function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, "\n      .cls-1 {\n        fill: #92d5d6;\n        fill-rule: evenodd;\n      }\n    "));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  id: "_",
  "data-name": "\\u201C",
  className: "cls-1",
  d: "M76.644,38.153a11.384,11.384,0,0,0-9.5-4.307,14.645,14.645,0,0,0-3.371.308q0-8.61,4.138-14.306A29.627,29.627,0,0,1,78.79,10.773L71.127,0A36.062,36.062,0,0,0,63.31,4.312a42.308,42.308,0,0,0-8.583,8.153,47.323,47.323,0,0,0-7.05,12.306,46.439,46.439,0,0,0-2.912,17.383q0,10.772,5.365,16.305A18.166,18.166,0,0,0,63.77,64a16.718,16.718,0,0,0,11.648-4.154q4.6-4.152,4.6-11.229A16.475,16.475,0,0,0,76.644,38.153Zm-44.752,0a11.384,11.384,0,0,0-9.5-4.307,14.644,14.644,0,0,0-3.372.308q0-8.61,4.138-14.306a29.626,29.626,0,0,1,10.881-9.075L26.375,0a36.043,36.043,0,0,0-7.816,4.307,42.269,42.269,0,0,0-8.583,8.153,47.327,47.327,0,0,0-7.05,12.306A46.44,46.44,0,0,0,.014,42.154q0,10.772,5.365,16.305A18.167,18.167,0,0,0,19.018,64a16.718,16.718,0,0,0,11.648-4.154q4.6-4.152,4.6-11.229A16.47,16.47,0,0,0,31.892,38.153Z"
});

var SvgQuoteLightGreen = function SvgQuoteLightGreen(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 80 64",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgQuoteLightGreen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/quote-light-green.eddc27ea.svg";
export { ForwardRef as ReactComponent };